var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAccessArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "12px",
    viewBox: "0 0 8 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icAccessArrow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MessengerInboxChatScreen-with-images",
    transform: "translate(-306.000000, -1376.000000)",
    strokeWidth: 2,
    stroke: "#535353"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(48.000000, 1367.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(31.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "access--arrow",
    transform: "translate(230.109489, 8.000000) scale(-1, 1) translate(-230.109489, -8.000000) translate(227.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-11",
    transform: "translate(2.683233, 5.000000) scale(-1, -1) translate(-2.683233, -5.000000) ",
    points: "0.225136719 0 5.20646559 4.96201867 0.16 10"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAccessArrow);
export default __webpack_public_path__ + "static/media/icAccessArrow.d60621ab6fbeb9490e0af8b046d0bf00.svg";
export { ForwardRef as ReactComponent };